import { render } from "./PersonRegistrationTagLoginView.vue.ts?vue&type=template&id=38dca7f4&scoped=true&ts=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./PersonRegistrationTagLoginView.vue?vue&type=template&id=38dca7f4&scoped=true&ts=true"
import script from "./PersonRegistrationTagLoginView.vue.ts?vue&type=script&lang=ts!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./PersonRegistrationTagLoginView.vue?vue&type=script&lang=ts"
export * from "./PersonRegistrationTagLoginView.vue.ts?vue&type=script&lang=ts!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./PersonRegistrationTagLoginView.vue?vue&type=script&lang=ts"

import "./PersonRegistrationTagLoginView.vue.scss?vue&type=style&index=0&id=38dca7f4&lang=scss&scoped=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./PersonRegistrationTagLoginView.vue?vue&type=style&index=0&id=38dca7f4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38dca7f4"],['__file',"src/apps/core-app-onboarding/views/PersonRegistrationTagLoginView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "38dca7f4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('38dca7f4', __exports__)) {
    api.reload('38dca7f4', __exports__)
  }
  
  module.hot.accept("./PersonRegistrationTagLoginView.vue.ts?vue&type=template&id=38dca7f4&scoped=true&ts=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./PersonRegistrationTagLoginView.vue?vue&type=template&id=38dca7f4&scoped=true&ts=true", () => {
    api.rerender('38dca7f4', render)
  })

}


export default __exports__